import React, { Component } from "react";
import ReactPhoneInput from "react-phone-input-2";
import { parsePhoneNumber } from "libphonenumber-js";

class PhoneInput extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }

  setError = () =>
    this.setState(({ error }, { addError, index }) => {
      if (!error) addError(index);
      return { error: true };
    });

  clearError = () =>
    this.setState(({ error }, { subtractError, index }) => {
      if (error) subtractError(index);
      return { error: false };
    });

  checkMobile = () => {
    const { value } = this.props;
    try {
      const mobile = parsePhoneNumber(value, "CA");
      if (!mobile.isValid()) this.setError();
    } catch (error) {
      if (value.length) this.setError();
    }
  };
  render() {
    const { error } = this.state;
    return (
      <ReactPhoneInput
        defaultCountry="ca"
        placeholder="Phone"
        disableCountryCode
        disableDropdown
        buttonClass="invite__phone-btn"
        inputClass={`invite__phone-input ${error && "invalid-mobile"}`}
        inputExtraProps={{ name: "mobile" }}
        containerClass="invite__phone-container"
        preferredCountries={["ca"]}
        onlyCountries={["ca", "us"]}
        onBlur={this.checkMobile}
        onFocus={this.clearError}
        {...this.props}
      />
    );
  }
}

export default PhoneInput;



// WEBPACK FOOTER //
// ./src/components/Referral/PhoneInput.js